// src/components/Sidebar.js
import React from "react";
import { Link } from "react-router-dom"; // For navigation if you are using React Router
import { useAuth } from "../context/AuthContext";

const Sidebar = ({ isOpen, setIsOpen }) => {
  const { adminRole } = useAuth();
  const allowedRolesForSuperAdmin = ["Super Admin"];
  const allowedRolesForSettings = ["Super Admin", "Supervisor"];
  const allowedRolesForPOS = ["Super Admin", "Supervisor", "Cashier"];

  return (
    <div onClick={() => setIsOpen(false)}>
      {/* Sidebar */}
      <div
        className={`lg:w-64 w-full bg-[#1C1C1C] text-white fixed top-0 left-0 h-full transition-all duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0 z-40`}
      >
        <div
          className={`px-3 py-3 ${
            isOpen ? " text-center" : ""
          }  font-semibold flex item-center `}
        >
          <svg
            className="h-6"
            viewBox="0 0 374 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M127.564 70.3301C123.019 70.3301 119.087 69.2796 115.769 67.1975C112.451 65.1154 109.919 62.3075 108.155 58.7738C106.39 55.24 105.508 51.3242 105.508 47.0264C105.508 42.7286 106.39 38.8128 108.155 35.279C109.919 31.7453 112.47 28.9564 115.769 26.8553C119.087 24.7732 123.019 23.7227 127.564 23.7227C131.017 23.7227 134.124 24.3339 136.885 25.5373C139.647 26.7598 141.987 28.4216 143.924 30.5228C145.861 32.6239 147.3 35.088 148.278 37.8768H142.831C141.68 35.088 139.858 32.8531 137.384 31.2104C134.891 29.5677 131.765 28.7463 128.005 28.7463C124.323 28.7463 121.177 29.5677 118.588 31.1913C115.999 32.8149 114.024 35.0116 112.7 37.7622C111.358 40.5128 110.705 43.6072 110.705 47.0455C110.705 50.4264 111.377 53.5209 112.7 56.2906C114.043 59.0603 115.999 61.257 118.588 62.8806C121.177 64.5042 124.323 65.3256 128.005 65.3256C131.784 65.3256 134.91 64.5042 137.384 62.8615C139.877 61.2188 141.68 58.9839 142.831 56.1951H148.278C147.319 58.9457 145.861 61.3907 143.924 63.5109C141.987 65.6312 139.647 67.3121 136.885 68.5346C134.124 69.738 131.017 70.3301 127.564 70.3301Z"
              fill="#67BADB"
            />
            <path
              d="M157.711 69.7965V24.2969H162.889V64.8301H187.804V69.7774H157.711V69.7965Z"
              fill="#67BADB"
            />
            <path
              d="M196.211 69.7965V24.2969H229.813V29.2441H201.389V44.5062H226.783V49.5299H201.389V64.8492H229.813V69.7965H196.211Z"
              fill="#67BADB"
            />
            <path
              d="M234.508 69.7969L253.898 24.3164H260.381L279.771 69.7969H274.037L268.456 56.5978H245.824L240.242 69.7969H234.508ZM247.818 51.8607H266.442L257.12 29.6648L247.818 51.8607Z"
              fill="#67BADB"
            />
            <path
              d="M287.273 69.7965V24.2969H293.277L321.49 62.5761V24.2969H326.668V69.7774H320.665L292.452 31.3644V69.7774H287.273V69.7965Z"
              fill="#67BADB"
            />
            <path
              d="M355.915 70.3306C351.408 70.3306 347.745 69.7193 344.945 68.5159C342.145 67.2934 340.035 65.6125 338.635 63.4732C337.235 61.3147 336.41 58.8888 336.18 56.1955H341.569C341.703 58.3922 342.451 60.1686 343.775 61.5248C345.117 62.881 346.863 63.8743 349.049 64.5046C351.236 65.1541 353.633 65.4597 356.261 65.4597C360.116 65.4597 363.184 64.7911 365.428 63.4349C367.672 62.0787 368.804 60.0731 368.804 57.418C368.804 55.8135 368.248 54.5146 367.116 53.5404C365.985 52.5471 364.489 51.7449 362.628 51.0954C360.768 50.446 358.735 49.8729 356.529 49.3381C354.323 48.8033 352.099 48.2493 349.874 47.6572C347.649 47.065 345.597 46.301 343.736 45.3841C341.876 44.4672 340.38 43.2829 339.248 41.8503C338.117 40.3986 337.561 38.5649 337.561 36.3109C337.561 32.6052 338.999 29.5872 341.876 27.2377C344.753 24.9074 349.03 23.7422 354.745 23.7422C358.792 23.7422 362.13 24.3534 364.757 25.5568C367.385 26.7793 369.341 28.3647 370.645 30.3322C371.949 32.2996 372.678 34.439 372.813 36.7312H367.5C367.231 34.439 366.081 32.5097 364.047 30.9243C362.014 29.3389 358.927 28.5557 354.726 28.5557C352.156 28.5557 350.066 28.8041 348.455 29.3198C346.843 29.8164 345.616 30.485 344.772 31.2872C343.928 32.0895 343.353 32.93 343.046 33.7895C342.739 34.6682 342.605 35.4896 342.605 36.2727C342.605 37.7817 343.161 39.0042 344.293 39.9402C345.424 40.8762 346.92 41.6593 348.781 42.2706C350.641 42.8818 352.693 43.4549 354.956 43.9515C357.2 44.4481 359.444 45.0212 361.688 45.6324C363.913 46.2437 365.965 47.0268 367.826 47.9628C369.686 48.8988 371.182 50.1022 372.314 51.573C373.445 53.0438 374.002 54.9157 374.002 57.2079C374.002 61.4293 372.391 64.6574 369.168 66.9305C365.946 69.2036 361.535 70.3306 355.915 70.3306Z"
              fill="#67BADB"
            />
            <path
              d="M80.0558 14.5171L77.409 4.39333C76.7377 1.81464 74.3786 0 71.6935 0H28.8082C26.123 0 23.7831 1.81464 23.0927 4.39333L20.4267 14.5744C20.1774 15.4913 20.7336 16.4463 21.6734 16.6755C22.594 16.9239 23.553 16.3699 23.7831 15.434L26.4491 5.25289V5.23379C26.6984 4.31692 27.6958 3.83939 28.5972 4.12591C29.2877 4.35513 30.0357 4.60344 30.0357 4.60344C32.2797 5.25289 34.5237 5.74953 36.7677 6.15066C41.2557 6.91472 45.7437 7.27764 50.2317 7.27764C54.7197 7.27764 59.2077 6.91472 63.6957 6.13156C65.9397 5.73043 68.1837 5.23379 70.4277 4.58434C70.4277 4.58434 71.1948 4.33602 71.8661 4.10681C72.7676 3.82029 73.7649 4.29782 74.0142 5.21469C74.0142 5.23379 74.0142 5.23379 74.0142 5.25289L76.6802 15.434C76.8911 16.2171 77.5816 16.7329 78.3488 16.7329C78.5789 16.7329 78.8091 16.6946 79.0392 16.58C79.8831 16.2553 80.2667 15.3575 80.0558 14.5171Z"
              fill="#FF8C00"
            />
            <path
              d="M90.3356 23.3225L89.7603 21.4123C89.2616 19.7696 87.9766 18.4898 86.3271 17.9932L84.4092 17.4201C83.6995 17.21 83.6995 16.2167 84.4092 16.0066L86.3271 15.4336C87.9766 14.9369 89.2616 13.6571 89.7603 12.0144L90.3356 10.1043C90.5466 9.39753 91.544 9.39753 91.7549 10.1043L92.3303 12.0144C92.829 13.6571 94.114 14.9369 95.7634 15.4336L97.6814 16.0066C98.391 16.2167 98.391 17.21 97.6814 17.4201L95.7634 17.9932C94.114 18.4898 92.829 19.7696 92.3303 21.4123L91.7549 23.3225C91.544 24.0101 90.5466 24.0101 90.3356 23.3225Z"
              fill="#66B8D9"
            />
            <path
              d="M41.2369 43.9141H26.2769C25.318 43.9141 24.5508 44.6781 24.5508 45.6332C24.5508 46.5883 25.318 47.3523 26.2769 47.3523H41.2369C42.1959 47.3523 42.9631 46.5883 42.9631 45.6332C42.9631 44.6781 42.1767 43.9141 41.2369 43.9141Z"
              fill="#FF8C00"
            />
            <path
              d="M72.7681 20.2281C70.294 20.2281 64.3292 19.9034 57.9616 23.5517C53.3777 26.1686 49.1965 29.9125 46.7032 34.8598C46.0895 36.1014 45.5716 37.4003 45.1305 38.7183C44.7085 40.0554 44.4209 41.4307 44.1907 42.806C44.0948 43.4936 43.9989 44.2004 43.9605 44.9071L43.9222 45.442L43.903 45.5757V45.7285V45.9577L43.8455 46.6454C43.7688 47.5431 43.6345 48.4409 43.4235 49.3196C43.0016 51.0578 42.3878 52.7387 41.5056 54.2859C41.0644 55.05 40.6041 55.814 40.0671 56.5208C39.5301 57.2276 38.9547 57.8961 38.3218 58.5264C37.6889 59.1568 37.0368 59.7489 36.3271 60.2838C35.6175 60.8186 34.8695 61.2962 34.1023 61.7355C32.5679 62.6333 30.8801 63.2636 29.1348 63.6838C28.2717 63.9131 27.3703 64.0468 26.4689 64.1423L25.7784 64.1996L25.0304 64.2378C24.5701 64.276 24.1098 64.2569 23.6495 64.276C22.7289 64.2569 21.7891 64.1805 20.8684 64.0277C19.9478 63.8749 19.0272 63.6838 18.1066 63.4164C14.4625 62.3467 10.9718 60.2265 8.15245 57.1894C7.8264 56.8455 7.46199 56.3871 7.0784 55.8905C4.48916 52.4331 3.18496 48.1544 3.53019 43.8566C3.54937 43.6273 3.56855 43.3981 3.60691 43.1689C4.89193 31.9755 14.5584 23.6854 25.8168 23.6854H36.7299V27.4484C36.7299 29.1485 38.13 30.5429 39.837 30.5429C41.333 30.5429 42.5988 29.4732 42.8865 28.0597C42.9249 27.9069 42.9632 27.7349 42.9632 27.563V20.2281C42.9632 20.2281 42.9632 20.209 42.944 20.209H25.8168C11.7774 20.209 0.116242 31.3642 0.00116485 45.3465C-0.133092 59.4624 11.3554 70.9615 25.4907 70.9615H25.8168C32.5296 70.9615 38.8204 68.3446 43.5386 63.6074C48.2568 58.8703 50.8268 52.5668 50.7693 45.8813V45.5757C50.7693 33.4845 60.6467 23.6472 72.7873 23.6472C80.5358 23.6472 87.3637 27.6585 91.2955 33.7137C92.1586 35.1845 97.8549 45.6903 89.953 55.0309C89.6461 55.3556 89.32 55.6803 89.0132 56.0051C86.3472 58.6602 83.4128 60.6467 80.2673 62.0793C79.481 62.4422 78.6754 62.767 77.8507 63.0344C77.4479 63.1872 77.026 63.3209 76.604 63.4546C76.4506 63.5119 76.2972 63.5501 76.1245 63.5883C75.9711 63.6265 75.7985 63.6647 75.6451 63.722L75.319 63.7984C74.4559 64.0468 73.5737 64.1423 72.6722 64.3142L71.9818 64.4097C71.7708 64.4479 71.5406 64.4479 71.3297 64.4861C71.0995 64.5243 70.8694 64.5434 70.6392 64.5625C70.3899 64.5816 70.1405 64.6198 69.9104 64.6198C69.6802 64.6198 69.4309 64.6389 69.2008 64.658L68.4911 64.6771C68.2418 64.6962 68.0116 64.6771 67.7623 64.6771C67.513 64.6771 67.2636 64.6771 67.0335 64.6771C66.0361 64.658 65.0196 64.5816 63.9839 64.4479C62.2194 64.1996 59.1315 62.7861 58.2684 62.0984C57.5972 61.5636 56.6382 61.4681 55.9861 62.022C55.1422 62.7097 55.1422 63.9704 55.9285 64.658C60.5892 68.7648 66.5923 71.0188 72.8065 71.0188C86.8651 71.0188 98.296 59.6343 98.296 45.633C98.296 31.6316 86.8267 20.2281 72.7681 20.2281Z"
              fill="#FF8C00"
            />
          </svg>
        </div>

        <ul className="mt-2 space-y-4 border-t border-gray-200 dark:border-gray-700 pt-6">
          {allowedRolesForSuperAdmin.includes(adminRole) && (
            <li>
              <Link
                to="/admins"
                className="flex items-center p-2 hover:bg-gray-700 font-semibold "
              >
                <svg
                  className="flex-shrink-0 w-5 h-5"
                  viewBox="0 0 60 68"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18 22C18 25.1826 19.2643 28.2348 21.5147 30.4853C23.7652 32.7357 26.8174 34 30 34C33.1826 34 36.2348 32.7357 38.4853 30.4853C40.7357 28.2348 42 25.1826 42 22C42 18.8174 40.7357 15.7652 38.4853 13.5147C36.2348 11.2643 33.1826 10 30 10C26.8174 10 23.7652 11.2643 21.5147 13.5147C19.2643 15.7652 18 18.8174 18 22ZM26.8594 40.7688L28.6031 43.675L25.4813 55.2906L22.1063 41.5188C21.9188 40.7594 21.1875 40.2625 20.4281 40.4594C13.8656 42.1 9 48.0437 9 55.1219C9 56.7156 10.2938 58 11.8781 58H24.225C24.225 58 24.225 58 24.2344 58H24.75H35.25H35.7656C35.7656 58 35.7656 58 35.775 58H48.1219C49.7156 58 51 56.7062 51 55.1219C51 48.0437 46.1344 42.1 39.5719 40.4594C38.8125 40.2719 38.0813 40.7688 37.8938 41.5188L34.5188 55.2906L31.3969 43.675L33.1406 40.7688C33.7406 39.7656 33.0188 38.5 31.8563 38.5H30H28.1531C26.9906 38.5 26.2688 39.775 26.8688 40.7688H26.8594Z"
                    fill="#FF8C00"
                  />
                </svg>
                <span className="ms-3"> Admin</span>
              </Link>
            </li>
          )}
          {allowedRolesForSuperAdmin.includes(adminRole) && (
            <li>
              <Link
                to="/clients"
                className="flex items-center p-2 hover:bg-gray-700 font-semibold "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  fill="#FF8C00"
                  stroke="#FF8C00"
                  className="flex-shrink-0 w-5 h-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
                  />
                </svg>
                <span className="ms-3">Clinets</span>
              </Link>
            </li>
          )}
          {allowedRolesForSettings.includes(adminRole) && (
            <li>
              <Link
                to="/branches"
                className="flex items-center p-2 hover:bg-gray-700 font-semibold "
              >
                <svg
                  className="flex-shrink-0 w-5 h-5"
                  viewBox="0 0 28 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.5 13.5C0.5 9.91958 1.92232 6.4858 4.45406 3.95406C6.9858 1.42232 10.4196 0 14 0C17.5804 0 21.0142 1.42232 23.5459 3.95406C26.0777 6.4858 27.5 9.91958 27.5 13.5C27.5 17.0804 26.0777 20.5142 23.5459 23.0459C21.0142 25.5777 17.5804 27 14 27C10.4196 27 6.9858 25.5777 4.45406 23.0459C1.92232 20.5142 0.5 17.0804 0.5 13.5ZM14 7.5C14.825 7.5 15.5 6.825 15.5 6C15.5 5.175 14.825 4.5 14 4.5C9.03125 4.5 5 8.53125 5 13.5C5 14.325 5.675 15 6.5 15C7.325 15 8 14.325 8 13.5C8 10.1906 10.6906 7.5 14 7.5ZM11 45V29.7281C11.975 29.9062 12.9781 30 14 30C15.0219 30 16.025 29.9062 17 29.7281V45C17 46.6594 15.6594 48 14 48C12.3406 48 11 46.6594 11 45Z"
                    fill="#FF8C00"
                  />
                </svg>
                <span className="ms-3">Branches</span>
              </Link>
            </li>
          )}
          {allowedRolesForSettings.includes(adminRole) && (
            <li>
              <Link
                to="/subscriptions"
                className="flex items-center p-2 hover:bg-gray-700 font-semibold "
              >
                <svg
                  className="flex-shrink-0 w-5 h-5"
                  viewBox="0 0 54 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_1_34)">
                    <path
                      d="M24 0H30C31.6594 0 33 1.34062 33 3V9C33 10.6594 31.6594 12 30 12H24C22.3406 12 21 10.6594 21 9V3C21 1.34062 22.3406 0 24 0ZM6 6H18V10.5C18 12.9844 20.0156 15 22.5 15H31.5C33.9844 15 36 12.9844 36 10.5V6H48C51.3094 6 54 8.69063 54 12V42C54 45.3094 51.3094 48 48 48H6C2.69063 48 0 45.3094 0 42V12C0 8.69063 2.69063 6 6 6ZM16.5 40.9969C16.5 41.55 16.95 42 17.5031 42H36.5062C37.0594 42 37.5094 41.55 37.5094 40.9969C37.5094 38.2312 35.2687 36 32.5125 36H21.5156C18.75 36 16.5187 38.2406 16.5187 40.9969H16.5ZM27 33C28.5913 33 30.1174 32.3679 31.2426 31.2426C32.3679 30.1174 33 28.5913 33 27C33 25.4087 32.3679 23.8826 31.2426 22.7574C30.1174 21.6321 28.5913 21 27 21C25.4087 21 23.8826 21.6321 22.7574 22.7574C21.6321 23.8826 21 25.4087 21 27C21 28.5913 21.6321 30.1174 22.7574 31.2426C23.8826 32.3679 25.4087 33 27 33Z"
                      fill="#FF8C00"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_34">
                      <rect width="54" height="48" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

                <span className="ms-3">Subscriptions</span>
              </Link>
            </li>
          )}
          {allowedRolesForSettings.includes(adminRole) && (
            <li>
              <Link
                to="/coupons"
                className="flex items-center p-2 hover:bg-gray-700 font-semibold "
              >
                <svg
                  className="flex-shrink-0 w-5 h-5"
                  viewBox="0 0 54 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 6C2.69063 6 0 8.69063 0 12V18C0 18.825 0.69375 19.4719 1.47187 19.7438C3.23438 20.3531 4.5 22.0312 4.5 24C4.5 25.9688 3.23438 27.6469 1.47187 28.2562C0.69375 28.5281 0 29.175 0 30V36C0 39.3094 2.69063 42 6 42H48C51.3094 42 54 39.3094 54 36V30C54 29.175 53.3062 28.5281 52.5281 28.2562C50.7656 27.6469 49.5 25.9688 49.5 24C49.5 22.0312 50.7656 20.3531 52.5281 19.7438C53.3062 19.4719 54 18.825 54 18V12C54 8.69063 51.3094 6 48 6H6ZM12 16.5V31.5C12 32.325 12.675 33 13.5 33H40.5C41.325 33 42 32.325 42 31.5V16.5C42 15.675 41.325 15 40.5 15H13.5C12.675 15 12 15.675 12 16.5ZM9 15C9 13.3406 10.3406 12 12 12H42C43.6594 12 45 13.3406 45 15V33C45 34.6594 43.6594 36 42 36H12C10.3406 36 9 34.6594 9 33V15Z"
                    fill="#FF8C00"
                  />
                </svg>

                <span className="ms-3">Coupons</span>
              </Link>
            </li>
          )}
          {allowedRolesForPOS.includes(adminRole) && (
            <li>
              <Link
                to="/pos"
                className="flex items-center p-2 hover:bg-gray-700 font-semibold "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#FF8C00"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="none"
                  className="flex-shrink-0 w-5 h-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V13.5Zm0 2.25h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V18Zm2.498-6.75h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V13.5Zm0 2.25h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V18Zm2.504-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5Zm0 2.25h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V18Zm2.498-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5ZM8.25 6h7.5v2.25h-7.5V6ZM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 0 0 2.25 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0 0 12 2.25Z"
                  />
                </svg>

                <span className="ms-3">POS</span>
              </Link>
            </li>
          )}
          {allowedRolesForSettings.includes(adminRole) && (
            <li>
              <Link
                to="/reports"
                className="flex items-center p-2 hover:bg-gray-700 font-semibold "
              >
                <svg
                  className="flex-shrink-0 w-5 h-5"
                  viewBox="0 0 36 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_1_38)">
                    <path
                      d="M6 0C2.69063 0 0 2.69063 0 6V42C0 45.3094 2.69063 48 6 48H30C33.3094 48 36 45.3094 36 42V15H24C22.3406 15 21 13.6594 21 12V0H6ZM24 0V12H36L24 0ZM10.5 24H25.5C26.325 24 27 24.675 27 25.5C27 26.325 26.325 27 25.5 27H10.5C9.675 27 9 26.325 9 25.5C9 24.675 9.675 24 10.5 24ZM10.5 30H25.5C26.325 30 27 30.675 27 31.5C27 32.325 26.325 33 25.5 33H10.5C9.675 33 9 32.325 9 31.5C9 30.675 9.675 30 10.5 30ZM10.5 36H25.5C26.325 36 27 36.675 27 37.5C27 38.325 26.325 39 25.5 39H10.5C9.675 39 9 38.325 9 37.5C9 36.675 9.675 36 10.5 36Z"
                      fill="#FF8C00"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_38">
                      <rect width="36" height="48" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

                <span className="ms-3">Reports</span>
              </Link>
            </li>
          )}
          {allowedRolesForSuperAdmin.includes(adminRole) && (
            <li>
              <Link
                to="/payments"
                className="flex items-center p-2 hover:bg-gray-700 font-semibold "
              >
                <svg
                  className="flex-shrink-0 w-5 h-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
<path  d="M17,6V4a1,1,0,0,0-1-1H13l-.5,2h-3L9,3H6A1,1,0,0,0,5,4V20a1,1,0,0,0,1,1h7.63A8,8,0,0,1,17,6Z" fill="#FF8C00" strokeWidth={2}></path>
<path  d="M19,11H16.5A1.5,1.5,0,0,0,15,12.5h0A1.5,1.5,0,0,0,16.5,14h1A1.5,1.5,0,0,1,19,15.5h0A1.5,1.5,0,0,1,17.5,17H15" fill= "none" stroke="#FF8C00" stroke-linecap= "round" stroke-linejoin= "round" stroke-width ={2}></path>
<path   d="M14,21H6a1,1,0,0,1-1-1V4A1,1,0,0,1,6,3H16a1,1,0,0,1,1,1V6"fill= "none" stroke="#FF8C00" stroke-linecap= "round" stroke-linejoin= "round" stroke-width ={2}></path>
<path d="M17,11V10m0,8V17M13,3H9l.5,2h3Z" fill= "none" stroke="#FF8C00" stroke-linecap= "round" stroke-linejoin= "round" stroke-width ={2}></path>
                </svg>
               <span className="ms-3"> Payments</span>
              </Link>
            </li>
          )}
          {allowedRolesForSettings.includes(adminRole) && (
            <li>
              <Link
                to="/settings"
                className="flex items-center p-2 hover:bg-gray-700 font-semibold "
              >
                <svg
                  className="flex-shrink-0 w-5 h-5"
                  viewBox="0 0 46 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M45.116 15.6188C45.416 16.4344 45.1629 17.3438 44.516 17.925L40.4567 21.6188C40.5598 22.3969 40.616 23.1938 40.616 24C40.616 24.8062 40.5598 25.6031 40.4567 26.3812L44.516 30.075C45.1629 30.6562 45.416 31.5656 45.116 32.3812C44.7035 33.4969 44.2067 34.5656 43.6348 35.5969L43.1942 36.3562C42.5754 37.3875 41.8817 38.3625 41.1223 39.2812C40.5692 39.9562 39.6504 40.1812 38.8254 39.9187L33.6035 38.2594C32.3473 39.225 30.9598 40.0312 29.4785 40.6406L28.3067 45.9938C28.1192 46.8469 27.4629 47.5219 26.6004 47.6625C25.3067 47.8781 23.9754 47.9906 22.616 47.9906C21.2567 47.9906 19.9254 47.8781 18.6317 47.6625C17.7692 47.5219 17.1129 46.8469 16.9254 45.9938L15.7535 40.6406C14.2723 40.0312 12.8848 39.225 11.6285 38.2594L6.41604 39.9281C5.59104 40.1906 4.67229 39.9562 4.11916 39.2906C3.35979 38.3719 2.66604 37.3969 2.04729 36.3656L1.60666 35.6062C1.03479 34.575 0.537915 33.5062 0.125415 32.3906C-0.174585 31.575 0.0785397 30.6656 0.725415 30.0844L4.78479 26.3906C4.68166 25.6031 4.62542 24.8062 4.62542 24C4.62542 23.1938 4.68166 22.3969 4.78479 21.6188L0.725415 17.925C0.0785397 17.3438 -0.174585 16.4344 0.125415 15.6188C0.537915 14.5031 1.03479 13.4344 1.60666 12.4031L2.04729 11.6437C2.66604 10.6125 3.35979 9.6375 4.11916 8.71875C4.67229 8.04375 5.59104 7.81875 6.41604 8.08125L11.6379 9.74063C12.8942 8.775 14.2817 7.96875 15.7629 7.35938L16.9348 2.00625C17.1223 1.15312 17.7785 0.478125 18.641 0.3375C19.9348 0.1125 21.266 0 22.6254 0C23.9848 0 25.316 0.1125 26.6098 0.328125C27.4723 0.46875 28.1285 1.14375 28.316 1.99687L29.4879 7.35C30.9692 7.95938 32.3567 8.76562 33.6129 9.73125L38.8348 8.07187C39.6598 7.80937 40.5785 8.04375 41.1317 8.70938C41.891 9.62813 42.5848 10.6031 43.2035 11.6344L43.6442 12.3937C44.216 13.425 44.7129 14.4937 45.1254 15.6094L45.116 15.6188ZM22.6254 31.5C24.6145 31.5 26.5222 30.7098 27.9287 29.3033C29.3352 27.8968 30.1254 25.9891 30.1254 24C30.1254 22.0109 29.3352 20.1032 27.9287 18.6967C26.5222 17.2902 24.6145 16.5 22.6254 16.5C20.6363 16.5 18.7286 17.2902 17.3221 18.6967C15.9156 20.1032 15.1254 22.0109 15.1254 24C15.1254 25.9891 15.9156 27.8968 17.3221 29.3033C18.7286 30.7098 20.6363 31.5 22.6254 31.5Z"
                    fill="#FF8C00"
                  />
                </svg>

                <span className="ms-3">Settings</span>
              </Link>
            </li>
          )}
          

      
        </ul>
      </div>

      {/* Content Area */}
      <div
        className={`lg:ml-64 transition-all duration-300 ease-in-out ${
          isOpen ? "ml-0" : "ml-0"
        } lg:ml-64`}
      >
        {/* Content goes here */}
      </div>
    </div>
  );
};

export default Sidebar;
